import CHIPSMENU from "./components/_menu.js";
class AppCrit {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "AppCrit";
		this.init();
	}

	init() {
		this.initMenu = new CHIPSMENU();
		console.log("AppCrit initialized");
	}
}

const appcrit = new AppCrit();
